import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { LaunchDialogService } from '../../../../core/modal';
import { UrlModule } from '../../../../core/routing';
import { ArticleImageModule, CounterInputModule, DropdownModule, IconThemeReverseModule } from '../../../../shared';
import { ActionButtonModule } from '../../../../shared/components/action-button';
import { ModalModule } from '../../../../shared/components/modal';
import { NotificationModule } from '../../../../shared/components/notification';
import { sampleOrderModalLayoutConfig } from './sample-order-modal-layout.config';
import { SampleOrderModalComponent } from './sample-order-modal.component';

@NgModule({
  declarations: [SampleOrderModalComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    UrlModule,
    RouterModule,
    ReactiveFormsModule,
    ArticleImageModule,
    CounterInputModule,
    DropdownModule,
    NotificationModule,
    IconThemeReverseModule,
    ActionButtonModule,
    KeyboardFocusModule,
    ModalModule,
  ],
  exports: [SampleOrderModalComponent],
})
export class SampleOrderModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(sampleOrderModalLayoutConfig);
  }
}
